"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require("babel-runtime/regenerator");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require("babel-runtime/helpers/asyncToGenerator");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require("babel-runtime/helpers/objectWithoutProperties");

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _ContextUserEvents = require("./ContextUserEvents");

var ContextUserEvents = _interopRequireWildcard(_ContextUserEvents);

var _eventsTab = require("../Context/eventsTab");

var UITabEvents = _interopRequireWildcard(_eventsTab);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Representation of an application's runtime context
 *
 * @class
 */
var Context = function () {
  /**
   * @param {AppEventEmitter} outgoingDispatcher the outgoing events dispatcher
   * @param {ContextHostUI} hostUI the interface for context supplied by the Deskpro ui component hosting the app
   * @param {ContextObject} object the interface for the context supplied by the Deskpro Object
   * @param {...*} rest
   * @constructor
   */
  function Context(_ref) {
    var outgoingDispatcher = _ref.outgoingDispatcher,
        hostUI = _ref.hostUI,
        object = _ref.object,
        rest = (0, _objectWithoutProperties3.default)(_ref, ["outgoingDispatcher", "hostUI", "object"]);
    (0, _classCallCheck3.default)(this, Context);

    this.props = (0, _extends3.default)({ outgoingDispatcher: outgoingDispatcher, hostUI: hostUI, object: object }, rest);
  }

  /**
   * The interface for the Deskpro UI component hosting the app
   *
   * @type {ContextHostUI}
   */


  (0, _createClass3.default)(Context, [{
    key: "available",


    /**
     * Check if an object of this type is available via `Context.get` in this context
     *
     * @param {String} objectType
     * @return {boolean}
     */
    value: function available(objectType) {
      return objectType === this.props.object.type;
    }

    /**
     * Returns one of the Deskpro Objects exposed by this context
     *
     * @param {String} objectType
     * @return {ContextObject}
     */

  }, {
    key: "get",
    value: function get(objectType) {
      if (!this.available(objectType)) {
        throw new Error("Object of type " + type + " is not available");
      }

      return this.props.object;
    }

    /**
     * Returns the data loaded by the Deskpro UI tab
     *
     * @private
     *
     * @method
     * @async
     * @return {Promise.<{}, Error>}
     */

  }, {
    key: "_getTabData",
    value: function () {
      var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", this.props.outgoingDispatcher.emitAsync(UITabEvents.EVENT_TAB_DATA, this.props.tabId));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function _getTabData() {
        return _ref2.apply(this, arguments);
      }

      return _getTabData;
    }()

    /**
     * Checks if a property exists in this context
     *
     * @method
     *
     * @param {String} propName
     * @return {boolean}
     */

  }, {
    key: "hasProperty",
    value: function hasProperty(propName) {
      return this.props.hasOwnProperty(propName);
    }
  }, {
    key: "getProperty",


    /**
     * Retrieves a property from this context
     *
     * @method
     *
     * @param {String} propName
     * @return {*}
     */
    value: function getProperty(propName) {
      if (this.props.hasOwnProperty(propName)) {
        return this.props[propName];
      }

      return undefined;
    }
  }, {
    key: "getMe",


    /**
     * Returns a representation of the currently authenticated user
     *
     * @public
     * @method
     * @async
     * @return {Promise.<Context~Me, Error>}
     */
    value: function () {
      var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", this.props.outgoingDispatcher.emitAsync(ContextUserEvents.EVENT_ME_GET));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getMe() {
        return _ref3.apply(this, arguments);
      }

      return getMe;
    }()

    /**
     * @method
     *
     * @return {Object}
     */

  }, {
    key: "toJS",
    value: function toJS() {
      return (0, _extends3.default)({}, this.props);
    }
  }, {
    key: "hostUI",
    get: function get() {
      return this.props.hostUI;
    }
  }]);
  return Context;
}();

exports.default = Context;

/**
 * Representation of the currently signed-in user
 *
 * @typedef {Object} Context~Me
 * @property {number} id
 * @property {object} avatar,
 * @property {boolean} can_admin,
 * @property {boolean} can_agent,
 * @property {boolean} can_billing,
 * @property {boolean} is_agent,
 * @property {boolean} is_confirmed,
 * @property {boolean} is_contact,
 * @property {boolean} is_deleted,
 * @property {boolean} is_disabled,
 * @property {boolean} is_user,
 * @property {boolean} was_agent,
 * @property {boolean} online,
 * @property {Array<String>} labels,
 * @property {Array<String>} teams,
 * @property {Array<object>} phone_numbers,
 * @property {String} date_created,
 * @property {String} date_last_login,
 * @property {String} name,
 * @property {String} display_name,
 * @property {String} first_name,
 * @property {String} last_name,
 * @property {Object} primary_email,
 * @property {Array.<String>} emails,
 * @property {String} gravatar_url,
 * @property {number} tickets_count,
 * @property {String} timezone
 */


//////////////////
// WEBPACK FOOTER
// ./node_modules/@deskpro/apps-sdk-core/lib/main/javascript/Core/Context.js
// module id = 162
// module chunks = 0